import { PhaserConfig, getDefaultConfigPhaser } from '../components/Phaser/types/config';

/**
 * Remove fields that are automatically populated by `mapImportedPhaserConfig`
 * so that JSON editors display only the user-defined configuration.
 */
export const stripPhaserAutoFields = (config?: PhaserConfig): PhaserConfig => {
    const sourceConfig = config ?? getDefaultConfigPhaser();

    const { scene, characters, objects, sounds, ...rest } = sourceConfig;

    const cleanedScene = scene ? { ...scene } : ({} as any);
    // Background is derived from the DB (scene image & mode), so hide it
    if (cleanedScene.background) {
        delete cleanedScene.background;
    }

    const cleanedCharacters = (characters || []).map((c) => {
        const { image_url, animations, ...remaining } = c;
        return remaining as any;
    });

    const cleanedObjects = (objects || []).map((o) => {
        const { immovable, pickable, pushable, decor, assets, ...remaining } = o;
        return remaining as any;
    });

    const cleanedSounds = (sounds || []).map((s) => {
        const { volume, loop, ...remaining } = s;
        return remaining as any;
    });

    return {
        ...rest,
        scene: cleanedScene,
        characters: cleanedCharacters,
        objects: cleanedObjects,
        sounds: cleanedSounds,
    } as PhaserConfig;
};

export default stripPhaserAutoFields;